// extracted by mini-css-extract-plugin
export default {"form":"SzdA_q3yELXsXXJxFp7c","bottom":"FYNs8sahb9w4vkqZUOPF","subrow":"q3G3GPNOlGHmC8KFU1ow"};